var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled/Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3342 16.2139L17.0564 14.491C17.2883 14.2618 17.5818 14.1049 17.9012 14.0394C18.2205 13.9739 18.552 14.0025 18.8555 14.1218L20.9544 14.9602C21.261 15.0847 21.5239 15.2972 21.71 15.5709C21.8961 15.8447 21.997 16.1674 22 16.4985V20.3442C21.9982 20.5694 21.9509 20.7919 21.8609 20.9983C21.7709 21.2047 21.6401 21.3908 21.4763 21.5453C21.3125 21.6998 21.1192 21.8195 20.9079 21.8973C20.6967 21.9751 20.4719 22.0093 20.2471 21.9979C5.5392 21.0826 2.57149 8.62239 2.01024 3.85368C1.98419 3.6195 2.00799 3.38246 2.08009 3.15814C2.15218 2.93383 2.27094 2.72733 2.42854 2.55223C2.58614 2.37713 2.77901 2.23739 2.99447 2.14222C3.20993 2.04704 3.44309 1.99859 3.67862 2.00003H7.3921C7.72347 2.00101 8.04698 2.10115 8.321 2.28756C8.59503 2.47397 8.80704 2.73814 8.92977 3.04607L9.7678 5.14584C9.89101 5.44817 9.92245 5.78011 9.85818 6.10021C9.79391 6.4203 9.63679 6.71436 9.40645 6.94565L7.68426 8.66854C7.68426 8.66854 8.67606 15.3832 15.3342 16.2139Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.68985cbc9de95c7dbcb81d02772963bf.svg";
export { ForwardRef as ReactComponent };